import {Fragment} from "react";

/**
 * One string per drawn line, joined with <br/>.
 *
 * The design breaks its display copy at chosen words — "DECLASSIFIED UPON /
 * MANIFEST LOCK", "SECURE YOUR PLACE / IN THE CREW MANIFEST" — and the client
 * reviews against those breaks, so the copy carries its own line array and the
 * browser is never left to pick. Several of these lines also sit within a
 * pixel or two of their column: "DECLASSIFIED UPON" measures 271.6 in a 270
 * box, so soft wrapping does not merely differ from the design, it differs
 * unpredictably with the font that happens to have loaded.
 */
export default function Lines({of}: {of: readonly string[]}) {
    return (
        <>
            {of.map((line, index) => (
                <Fragment key={index}>
                    {index > 0 ? <br/> : null}
                    {line}
                </Fragment>
            ))}
        </>
    );
}
